module.exports = __webpack_public_path__ + "static/media/step3.637592e0.png";